import {useState, useEffect} from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Box from "@mui/material/Box";

import Loading from '../../common/Loading';

export default function LoadListFilterSortByList(props) {
    //console.debug("RTS Break LoadListFilterSortByList");

    const [isLoading, setIsLoading] = useState(true);

    const [sortBy, setSortBy] = useState();
    const [repoSortBys, setRepoSortBys] = useState(); 


    useEffect(() => {
        if(props.sortBy===null){
            setSortBy(0);
        }
        else{
            setSortBy(props.sortBy);
        }

        setRepoSortBys([{id:0, label:"Ship Date Increasing"},
                         {id:1, label:"Ship Date Decreasing"},
                         {id:2, label:"Remaining Product Increasing"},
                         {id:3, label:"Remaining Product Decreasing"},
                         {id:4, label:"Deferral Remaining Increasing"},
                         {id:5, label:"Deferral Remaining Decreasing"},
                         {id:6, label:"Battery Level Increasing"},
                         {id:7, label:"Battery Level Decreasing"},
                        ]);

        setIsLoading(false);
    }, [props]); 


    function valChange(e, val){
        props.setSortByFx(val.id);
        setSortBy(val.id);
    }    


    if(isLoading){
        return(
            <Loading />
        );
    }
    
    
    return(
        <>
            <Autocomplete
                options={repoSortBys}
                renderInput={(params) => <TextField {...params} label="Sort By" size="small" />}
                value={repoSortBys.find(v => v.id==sortBy)}
                onChange={valChange}
                getOptionLabel={(repoSortBys) => repoSortBys.label}
                renderOption={(props, repoSortBys) => (
                    <Box component="li" {...props} key={repoSortBys.id}>
                        {repoSortBys.label}
                    </Box>
                )}
            />
        </>
    );
}

